import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs = [{
  q: '¿Cómo accedo a la app?',
  a: 'Con el mismo correo que usaste para comprar el producto. Ese email queda habilitado como tu acceso: lo ingresas, ves el link de descarga e instalas la app en tu celular.'
}, {
  q: '¿Qué correo debo usar al comprar?',
  a: 'El acceso queda vinculado exactamente al correo con el que hiciste la compra, así que usa uno al que tengas acceso desde tu celular. Si te equivocaste, escríbenos y lo corregimos.'
}, {
  q: '¿Necesito descargarla de una tienda de aplicaciones?',
  a: 'No hace falta. La app se instala directamente desde tu link, en un par de toques y en menos de un minuto. Sin complicaciones ni cuentas nuevas.'
}, {
  q: '¿Funciona en Android e iPhone?',
  a: 'Sí, funciona perfecto en ambos. Da igual el celular que tengas: si puedes abrir un enlace y navegar, puedes usar tu app sin problema.'
}, {
  q: '¿Por cuánto tiempo tengo acceso?',
  a: 'El acceso es de por vida. Puedes hacer el programa a tu ritmo, repetirlo cuando lo necesites y volver a tus recursos siempre que quieras.'
}, {
  q: '¿Qué pasa si no sé usar apps?',
  a: 'No te preocupes, está pensada justo para eso. Todo es simple, guiado y cálido, con pasos claros cada día. Y si algo no te queda claro, siempre puedes escribirnos.'
}, {
  q: '¿Necesito saber de hormonas para usar esta app?',
  a: 'No. La app está diseñada para cualquier mujer, sin conocimientos previos. Todo está explicado de forma simple, paso a paso, día por día.'
}, {
  q: '¿Funciona si tengo más de 50 años o estoy en menopausia?',
  a: 'Sí. El método está pensado especialmente para mujeres en etapa de cambio hormonal. La menopausia y perimenopausia son el momento ideal para aplicarlo.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-crema py-20 sm:py-28" data-id="element-14" data-mp="2p4lulsc8pqfs">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-15" data-mp="2u2neuglejvsu">
        <Reveal className="text-center" data-id="element-16" data-mp="2u36xjzivmo7x">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-17" data-mp="2z1rm31ornjgj">
            Preguntas frecuentes
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-18" data-mp="334em3pvlcaot">
            Todo lo que quieres saber antes de empezar.
          </p>
        </Reveal>

        <div className="mt-10 space-y-4" data-id="element-19" data-mp="380bwzgo34ou7">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <Reveal key={f.q} delay={i * 0.05} data-id="element-20" data-mp="3hrpwhog1donc" data-mpi={i}>
                <div className="overflow-hidden rounded-2xl border border-nude/70 bg-white" data-id="element-21" data-mp="3huccmcgztch6">
                  <h3 data-id="element-22" data-mp="3mqj7993xv1jt">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 sm:px-6" data-id="element-23" data-mp="3qsxr9wjcg7co">
                      <span className="font-serif text-lg font-semibold text-tinta sm:text-xl" data-id="element-24" data-mp="1f49f8ygazzol">
                        {f.q}
                      </span>
                      <motion.span animate={{
                    rotate: isOpen ? 45 : 0
                  }} transition={{
                    duration: 0.25
                  }} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-rosa/15 text-rosa-dark" data-id="element-25" data-mp="165nz19yb0wqz">
                        <PlusIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-26" data-mp="1p4jroguil32p" />
                      </motion.span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-27" data-mp="2mkz1yiirtq4a">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: [0.22, 1, 0.36, 1]
                }} data-id="element-28" data-mp="2hqco88p7vlh1">
                        <p className="px-5 pb-6 text-base leading-relaxed text-tinta/75 sm:px-6" data-id="element-29" data-mp="2bbce9zt5uohf">
                          {f.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}